import React from 'react';
import ReactDOM from "react-dom";
import BookingForm from "./BookingForm";
import Typography from "@mui/material/Typography";
import {Container} from "@mui/material";
import {makeStyles} from "@mui/styles";
import SearchEngine from "./Booking/Search/SearchEngine";
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing(1),
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    completed: {
        display: 'inline-block',
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    mainContent:{
        paddingTop:40
    }
}));
const BookingSearch = () => {
    const classes = useStyles();
    return (
        <Container maxWidth="lg" className={classes.mainContent}>
            {/*<h1 className="dive2019">Adventure Awaits!</h1>*/}
            <SearchEngine/>
        </Container>
    );
};

export default BookingSearch;
if (document.getElementById('bookingSearch')) {
    ReactDOM.render(<BookingSearch/>, document.getElementById('bookingSearch'));
}
